import { gql } from '@apollo/client'
import { head, pipe, propOr } from 'ramda'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useForm } from './FormLoader'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormReplyState = () => React.useContext(Context)
export const useFormReply = () => pipe(propOr([], 'formReplies'), head)(useFormReplyState())

export const useReplies = () => {
  const replies = useFormReply()?.replies || []
  return sortReplies(replies)
}

const QUERY = gql`
  query FormReplies($number: [Integer], $formId: [Integer]) {
    formReplies(filter: { numbers: $number, formIds: $formId, includeDeleted: true }) {
      id
      number
      formId
      insertedAt
      place {
        id
        name
        resume
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          reference
          parentReference
          description
          documents {
            id
            src
            type
            description
          }
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const FormRepliesLoader = ({ children, number, uncontrolledChildren }) => {
  const form = useForm()

  const { data, ...state } = useQuery(QUERY, {
    variables: { number, formId: form?.id },
    client: formsClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default FormRepliesLoader
